export enum Views {
  cardView = 'cardView',
  tableView = 'tableView',
  manageView = 'manageView',
}

export enum SortingOrder {
  ascending = 'asc',
  descending = 'desc',
}

export enum UnauthorizedEnums {
  title = 'ICE Admin',
  accessForbidden = 'Access Forbidden',
  accessForbiddenStatement = 'You do not have permission to access this page.',
  backToLogin = 'Back to Login',
  requestAccess = 'If you require access, contact our',
  requestAccessMailSubject = 'Need Access to ICE Admin $env$',
  requestAccessMailBodyLine1 = 'Hello Support Team,',
  requestAccessMailBodyLine2 = "I'm reaching out because I'm unable to access ICE Admin $env$, encountering the 403 page.",
  requestAccessMailBodyLine3 = 'Kindly grant me the necessary access permissions for this application.',
}

export enum Modes {
  editMode = 'editMode',
  viewMode = 'viewMode',
}

export enum FailureMessages {
  search_Results_Error = 'Unable to retrieve search results.',
}

export enum FeaturesCreationFlowMessages {
  titlePlaceHolder = 'Feature Name',
  title = "What is your feature's name?",
  title_textToHighlight = "feature's name",
  subTitle_Title = 'Enter the name of the feature that will help implement a unique capability in ICE. You can change it anytime you want.',
  description_title = ' Provide a feature description',
  description_title_textToHighlight = 'feature description',
  description_subtitle = 'In a few lines, describe what this feature does and why it is necessary.',
  cardTypeTitle = 'Select a card type to appear in the ICE panel',
  cardTypeTitle_textToHighlight = 'card type',
  cardTypeTitle_subtitle = 'Hero cards have high priority and are always displayed at the top. You can use multiple Hero cards. The Regular card allows you to select a custom icon and includes the feature description added previously.',
  pluginTitle = 'Select the plugin associated with this feature',
  pluginTitle_textToHighlight = 'plugin',
  pluginTitle_subtitle = 'Plugins are required to define features. If you want to use a custom plugin that is not listed here, create the plugin first.',
  enableDisableMessage = 'When do you want to enable this feature?',
  featureIconTitle = 'Pick an icon for the feature card',
  featureIconTitle_textToHighlight = 'icon',
  excludeTitle = 'Do you want to exclude this feature from the list displayed in the ICE panel?',
  excludeTitle_textToHighlight = 'exclude',
  excludeSubtitle = 'Excluding this feature from the ICE panel list will make it available internally but invisible to the end user. This makes it useful to test work-in-progress features.',
  displayOrderTitle = 'Pick a display order for this feature',
  displayOrderTitle_textToHighlight = 'display order',
  displayOrderSubtitle = 'Below are all the features associated with ICE right now. You can reorder the feature cards by dragging and dropping them.',
  enable_disable_textToHighlight = 'enable',
  enable_disable_subtitle = 'When you enable this feature, it will appear in Capabilities under product configurations. This is useful for customizing ICE.',
  cannot_enable_feature = 'You can enable this feature only after linking a plugin to it.',
}

export enum CustomersCreationFlowMessages {
  titlePlaceHolder = 'Customer Name',
  title = "What is your customer's name?",
  title_textToHighlight = "customer's name",
  subTitle_Title = 'Enter the name of the customer for whom ICE needs to be customized. You can change it anytime you want.',
  siteId_PlaceHolder = 'Customer Site ID',
  siteId_Title = "What is your customer's site ID?",
  siteId_Title_textToHighlight = "customer's site ID",
  siteId_subtitle = 'Every Broadcom customer has a unique site ID associated with them. If you do not have it handy, you can update it later.',
  description_title = 'Provide a customer description',
  description_title_textToHighlight = 'customer description',
  description_subtitle = 'In a few lines, describe why you want a customized ICE experience for this customer.',
  enableDisableMessage = 'When do you want to enable this customer?',
  skip_CheckBox = ' I’m not sure; I will add it later.',
  enable_disable_textToHighlight = 'enable',
  enable_disable_subtitle = 'When you enable this customer, they can be associated with product(s) to personalize their ICE experience.',
}
export enum IntegrationsCreationFlowMessages {
  titlePlaceHolder = 'Integration Name',
  title = "What is your integration's name?",
  title_textToHighlight = "integration's name",
  subTitle_Title = 'Enter the name of the integration needed to extend the capabilities of ICE. You can change it anytime you want.',
  description_title = 'Provide an integration description',
  description_title_textToHighlight = 'integration description',
  description_subtitle = 'In a few lines, describe what this integration does and why it is necessary.',
  enable_disable_textToHighlight = 'enable',
  enable_disable_subtitle = 'When you enable this integration, it will appear in Capabilities under product configurations. This is useful for customizing ICE.',
}

export enum ProductsCreationFlowMessages {
  title = "What is your product's name?",
  title_textToHighlight = "product's name",
  titlePlaceholder = 'Product Name',
  subTitle_Title = 'Enter the name of the product that needs to be ICE-enabled. You can change it anytime you want.',
  description_title = 'Provide a product description',
  description_title_textToHighlight = 'product description',
  description_subtitle = 'In a few lines, describe your product to provide some context about it.',
  productDisplayTitle = 'Set a custom title for the ICE panel',
  productDisplayTitle_textToHighlight = 'custom title',
  productDisplayTitle_subtitle = "You can create a custom title for the ICE panel; the default title is 'Help'.",
  productDisplayTitle_placeHolder = 'Help',
  ice_sideBar = 'Do not display the custom title on the ICE panel.',
  poc_title = 'Provide the email address of the primary stakeholder',
  poc_title_textToHighlight = 'primary stakeholder',
  poc_subTitle = 'They will receive regular product updates from ICE, including service quality, notification updates, analytics, and more.',
  poc_Placeholder = 'example@email.com',
  admin_poc_title = 'Provide the email address of the product manager',
  admin_poc_subtitle = 'They can take administrative actions in this product such as adding, editing, and deleting configurations, and more.',
  admin_poc_title_textToHighlight = 'product manager',
  admin_poc_Placeholder = 'example@email.com',
  version_title = 'What is this product’s baseline version?',
  version_title_textToHighlight = 'baseline version',
  version_subtitle = 'Enter the product version for which ICE will be enabled. If you do not want to specify a version or are unsure, enter “@latest”.',
  version_placeHolder = 'Baseline version',
  customer_title = 'Select the customer(s) you want to associate with the product',
  customer_title_textToHighlight = 'customer(s)',
  customer_subtitle = 'By default, ICE will be associated with all customers. If you wish to associate ICE with only specific customers, select them from the list.',
  cusotmer_later = 'I will do this later',
  include_document_title = 'Do you need to include documentation from other related products?',
  include_document_title_textToHighlight = 'include documentation',
  include_document_subtitle = 'To display documentation from multiple related products in this product, select them in the next step.',
  related_products = 'Select the related product(s)',
  related_products_textToHighlight = 'related product(s)',
  related_products_subtitle = 'To display documentation from multiple related products in this product, select them here.',
  enableDisableMessage = 'When do you want to enable ICE on this product?',
  enable_disable_textToHighlight = 'enable',
  enable_disable_subtitle = ' ',
  optinalDescription = "If you choose not to customize your product display title, then it will be set to 'Help' by default.",

  addProduct = 'Add a product',
}
export enum Types {
  customer = 'Customer',
  product = 'Product',
  plugin = 'Plugin',
  feature = 'Feature',
  connector = 'Connector',
  integration = 'Integration',
  ice = 'ICE',
  config = 'Configuration',
  campaign = 'Campaign',
  notification = 'Notification',
}

export const SearchTypes = {
  Product: ['Products', 'Productsearch', 'ProductsEnabled'],
  Customer: ['Customer', 'Customersearch', 'CustomersEnabled'],
  Plugin: ['Plugins', 'Pluginsearch', 'PluginEnabled'],
  Connector: ['Connectors', 'Connectorsearch', 'ConnectorsEnabled'],
  Integration: ['Integrations', 'Integrationsearch', 'IntegrationsEnabled'],
  Feature: ['Features', 'Featuresearch', 'FeatureEnabled'],
  Campaign: ['Campaigns', 'CampaignsSearch', 'CampaignsEnabled'],
  ICE: ['', '', ''],
  Configuration: ['', '', ''],
  Notification: ['', '', ''],
};

export enum ManagaeViewInformation {
  editableContent = 'Edit/update a field by clicking anywhere within it',
}
export enum AppBarEnum {
  ICEHelp = 'Help',
}

export const getViewableContent = (
  type: string,
  coreMessageNotRequired?: boolean
) => {
  return coreMessageNotRequired
    ? `Except the below switch ("Yes/No"), you cannot edit any details.`
    : `This is a core ${type.toLowerCase()}. Except the below switch ("Yes/No"), you cannot edit other details or delete this ${type.toLowerCase()}.`;
};

export enum ConfigurationEnums {
  noCustomConfigs = 'Click on a product on the left to view its custom configurations.',
}
export const AddScreenMessages = {
  product: {
    message: 'No products here yet.',
    addMessage: 'Onboard a Product Now',
  },
  customer: {
    message: 'No customers here yet.',
    addMessage: 'Onboard a Customer Now',
  },
  plugins: {
    message: 'No plugins here yet.',
    addMessage: 'Add a Plugin Now',
  },
  integrations: {
    message: 'No integrations here yet.',
    addMessage: 'Add an Integration Now',
  },
  connectors: {
    message: 'No connectors here yet.',
    addMessage: 'Add a Connector Now',
  },
  campaigns: {
    message: 'No campaigns here yet.',
    addMessage: 'Add a Campaign Now',
  },
};

export enum ConnectorsCreationFlowMessages {
  titlePlaceHolder = 'Connector Name',
  title = 'What is your connector’s name?',
  title_textToHighlight = 'connector’s name',
  subTitle_Title = `Enter the name of the connector that will help support a feature in ICE. You can change it anytime you want.`,
  description_title = 'Provide a connector description',
  description_title_textToHighlight = 'connector description',
  description_subtitle = 'In a few lines, describe what this connector does and why it is necessary.',
  connectorURL_title = 'Provide the connector URL',
  connectorURL_title_textToHighlight = 'connector URL',
  connectorURL_subtitle = 'Enter the endpoint or location of this connector.',
  connectorURL_placeHolder = 'http://www.example.com/index.html',
  providerKey_title = 'Enter your provider key',
  providerKey_title_textToHighlight = 'provider key',
  providerKey_subtitle = ' This step is optional; the key is required only if the URL is authenticated.',
  providerKey_placeHolder = 'Provider Key',
  environment_title = 'On which environment do you want to enable this connector?',
  features_title = 'Select feature(s)',
  features_title_textToHighlight = 'feature(s)',
  features_subtitle = 'At least one feature must be associated with this connector. You can link as many features as required to run with this connector.',
  enableDisableMessage = 'When do you want to enable this connector?',
  refreshInterval_primary_title = 'Provide a',
  refeshInterval_contrast_title = 'refresh interval',
  refreshInterval_secondary_title = 'for this connector',
  refreshInterval_primary_subtitle = 'To access the latest data, set the refresh interval for this connector. The interval must be between 15 minutes and 999 days, depending on how frequently your data changes.',
  enable_disable_textToHighlight = 'enable',
  enable_disable_subtitle = 'When you enable this connector, it will appear in Capabilities under product configurations. This is useful for customizing ICE.',
}

export enum sessionKeys {
  viewTypes = 'viewModes',
  pastUrl = 'pastUrl',
}

export enum PluginsCreationFlowMessages {
  titlePlaceHolder = 'Plugin Name',
  title = "What is your  plugin's name?",
  title_textToHighlight = "plugin's name",
  subTitle_Title = `Enter the name of the plugin that will help implement a feature in ICE. You can change it anytime you want.`,
  description_title = 'Provide a plugin description',
  description_title_textToHighlight = 'plugin description',
  description_subtitle = 'Describe what this plugin does and why it is necessary.',
  pluginCard_title = 'Select a card type for this plugin',
  pluginCard_title_textToHighlight = 'card type',
  pluginCard_subtitle = 'Hero cards have high priority and are always displayed at the top. You can use multiple Hero cards. The Regular card allows you to select a custom icon and includes the plugin description added previously.',
  pluginIcon_title = 'Pick an icon for the plugin card.',
  pluginIcon_title_textToHighlight = 'icon',
  pluginBinary_title = 'Upload your',
  pluginBinary_title_contrastText = 'plugin binary file',
  pluginBinary_subtitle = ' ',
  enableDisableMessage = 'When do you want to enable this plugin?',
  enable_disable_textToHighlight = 'enable',
  enable_disable_subtitle = 'When you enable this plugin, it will appear in Capabilities under product configurations. This is useful for customizing ICE.',
  skip_CheckBox = "Don't see your plugin? No problem, you can complete this later. Remember, you can enable this feature only after linking a plugin to it.",
}

export enum HazardousFlowMessages {
  title = 'Caution',
  popup_title = 'Confirm',
  cancel_button = 'Cancel',
  delete_button = 'Delete',
  stop_button = 'Stop',
}

export enum ProgressStatus {
  none = 'none',
  saving = 'saving',
  saved = 'saved',
  error = 'error',
}

export enum progressInformation {
  saving = 'Saving... ',
  saved = 'Changes saved',
  error = 'There is a problem in saving your field. Try again in some time.',
}

export const vowelTitles = ['Integrations'];

export const getNoRowsMessage = (type: string) => {
  return `We couldn't find ${
    vowelTitles.findIndex((currentType) => type === currentType) >= 0
      ? 'an'
      : 'a'
  } ${type.toLowerCase().substring(0, type.length - 1)} with this name.`;
};

export const HazardousDynamicMessages = {
  getSubtitle: (type: string) => {
    return `Delete this ${type}?`;
  },
  getCautionMessage: (type: string) => {
    return `This action cannot be reversed. If you ${
      type === Types.campaign ? 'stop' : 'delete'
    } this ${type.toLowerCase()}, you cannot recover it.`;
  },
  getConfirmMessage: (type: string) => {
    return `I definitely want to ${
      type === Types.campaign ? 'stop' : 'delete'
    } this ${type.toLowerCase()}`;
  },
  getPrimaryCautionMessage: (type: string) => {
    return `Deleting this ${type.toLowerCase()} could have permanent effects on other connected functionalities.`;
  },
};

export const charLimits = {
  max125: 'Maximum limit: 125 characters',
};

export enum routeEnums {
  addRoute = 'Add New Route',
  addNewRoute = 'Add a Route',
  configure = `Customize the ICE behavior for specific application routes (URLs) by adding them here. You can choose what should be displayed to users by setting the Display Text field, and specify comma-separated keywords to override the default search behavior for that route. Using custom keywords can help you narrow down the search results for this page and improve the user experience.`,
  routes = 'Routes',
  path = 'Path',
  pathPlaceHolder = 'E.g. /path/to/page.html',
  displayName = 'Display Name',
  displayNamePlaceHolder = 'Enter your display name here',
  searchKeywords = 'Search keywords',
  searchKeywordsPlaceHolder = 'Keyword 1,Keyword 2, etc.',
}
export enum searchCardEnums {
  title = 'Sorry, no results found.',
  optionalDesscription = 'Try searching for something else.',
}

export enum customersProductEnums {
  addRoute = 'Add Another Route',
  configure = `All customers of this product have default access to ICE. However, you can choose specific customers to customize their ICE experience. You can also use this option to onboard or offboard specific customers from ICE. If no customers are selected here, the configuration will not apply to any customer.`,
  customers = 'Customers',
  allCustomers = 'Enable this configuration of ICE for all the customers of this product.',
  specificCustomers = 'Enable this configuration of ICE for specific customers already onboarded to ICE Admin.',
  labelAllEnabledCustomers = 'For All Customers',
  labelSpecificCustomers = 'For Specific Customers',
}

export enum versionProductEnums {
  version = 'Versions',
  configure = `Add or configure versions for a new release, select the version in which to show ICE or delete unnecessary versions. You can only delete versions from the baseline configuration. If deleting the only selected version, add or select another version first, as at least one version must always be selected.`,
  addVersion = 'Add New Version',
  labelAllVersion = 'For all product versions.',
  labelLatestVersion = 'For latest product version.',
  labelSpecificVersion = 'For specific product versions.',
  labelCustomCondition = 'Specify custom condition.',
  duplicateVersionMessage = 'Duplicate version exists.',
  emptyVersion = 'Version cannot be empty.',
}

export enum capabilitiesProductEnums {
  capabilities = 'Capabilities',
  configure = `Select the capabilities you want to include in this configuration. By default, they match the capabilities in the product's baseline configuration.`,
  features = 'Features',
  integrations = 'Integrations',
  connectors = 'Connectors',
  plugins = 'Plugins',
}

export enum urlPatternsProductEnums {
  urlPatterns = 'URL Patterns',
  configure = 'Add URL patterns for this configuration.',
  addNew = 'Add a URL Pattern',
}

export enum urlPatternsTableEnums {
  url = 'URL',
  enable = 'Exclude hash route?',
  displayTerm = 'Display Terms',
  searchTerm = 'Search Terms',
  actions = 'Actions',
  noDataFound = 'No URL patterns have been added yet.',
}

export enum enableConfigIce {
  enable = 'Enable ICE',
}

export enum productGeneralEnum {
  deleteSuccessMessgae = 'This configuration has been deleted successfully',
  deleteFailureMessage = 'Unable to delete this configuration',
  editFailureMessage = 'Unable to edit this product',
  displayTitleOnIce = 'Display Custom Title on ICE Panel',
  name = 'Configuration Name',
  title = 'About This Configuration',
  displayName = 'Custom Title',
  manage = 'Configuration Actions',
  remove = 'Remove This Configuration',
  duplicate = 'Duplicate This Configuration',
  duplicateMessage = 'Copy this configuration to use as a starting point for your customizations.',
  message = 'Deleting this configuration will permanently remove it from the system. This action cannot be undone.',
}
export enum ManageProductEnum {
  titleLabel = 'Product Title',
  titlePlaceHolder = 'Product Title',
  displayNameLabel = 'Custom Title',
  displayNamePlaceHolder = 'Help',
  descriptionLabel = 'About This Product',
  pocLabel = 'Primary Stakeholder',
  pocPlaceHolder = 'example@email.com',
  adminPocLabel = 'Product Manager',
  adminPocPlaceHolder = 'example@email.com',
  baselineVersionLabel = 'Baseline Version',
  baselineVersionPlaceHolder = 'Baseline Version',
  customerAssociatedLabel = 'Associated Customers',
  customerAssociatedEditLabel = 'Edit Associated Customers',
  linkedProductsLabel = 'Related Products',
  relatedProductsLabel = 'Related Products',
  relatedProductsEditLabel = 'Edit Related Products',
  productKeysLabel = 'Product Keys',
  productKeysSubtitle = 'Environment specific product keys are used to integrate ICE with your product.',
  productNotAssociated = 'No products associated',
  productReadOnlyMessage = 'You cannot edit any of the details on this page.',
}

export enum productGeneralLabelEnum {
  configName = 'Configuration Name',
  configHelperText = 'Maximum Limit: 125 Characters',
  configNameEmptyHelperText = 'A name is needed to identify this configuration.',
  configCannotBeBaseline = "The configuration name cannot be 'Untitled Configuration' or 'Baseline Configuration'",
  uniqueConfigName = 'Duplicate configuration exists',
  errorMessage = 'The configuration name cannot exceed 125 characters.',
}

export enum productDescriptionEnum {
  descriptionLabel = 'Describe your configuration to provide some context about it.',
  title = 'Provide some more context about the configuration you are adding.',
}

export enum customeFieldRenderer {
  limit = 'Maximum limit: 256 characters',
  textFieldLimit = 'Maximum limit: 125 characters',
}

export enum productGeneralTitleEnum {
  helperText = 'If enabled, this custom title will be displayed on the ICE panel.',
  title = 'Custom Title for ICE Panel',
  required = 'This field is required.',
  noTitle = 'If you do not provide a custom title for this configuration, the product title will be displayed by default instead.',
  titlePlaceHolder = 'ICE will show this title on the side panel',
}

export enum productCreationEnum {
  subtitlePartLast = 'is still in progress. Are you sure you want to leave without completing it?',
  content = "If you leave now, you'll have to start over.",
  subtitlePartFirst = 'Your creation',
  selectRelatedProducts = 'Related Product(s)',
  isUmbrella = 'Related Products',
  noProduct = 'No Products available',
  description = 'Description',
  productName = 'Product Name',
  enableDisableProducts = 'Enable Product',
  productIdentifier = 'Product Identifier',
  productIdentifierExistsMessage = 'Duplicate product identifier exists',
  noCustomerFoundMessage = 'No customers available.',
  customerLabel = 'Customers',
  adminPOCLable = 'Product Manager',
  baselineLabel = 'Baseline Version',
  displayTitleLabel = 'Custom Title',
  productTitleLabel = 'Product Name',
  pocLabel = 'Primary Stakeholder',
  invalidEmailMessage = 'Enter a valid email address',
  titleExistsMessage = 'Duplicate product exists',
  customerName = 'Customer Name',
  searchCustomer = 'Search Customer',
  productIdentifierValidationMessage = 'The product identifier may contain only alphanumeric characters, hyphens and underscores.',
  selectCustomers = 'Customers',
  enableDisable = 'Enable Product',
  createLabel = 'Create Product',
}

export enum productEditEnum {
  editUnableMessage = 'Unable to edit this product.',
}

export enum creationFlowEnum {
  description = 'Description',
}

export enum generalEnums {
  cancel = 'Cancel',
}

export enum productListEnum {
  enabledProducts = 'Enabled Configurations',
  totalNumberOfConfigurations = 'Total Configurations',
  customerSpecificConfigurations = 'Has Customer Specific Configurations',
  iceStatus = 'ICE Status',
  noRowMessage = 'No products available.',
}

export enum cardHeights {
  product = 230,
  customer = 230,
  plugin = 230,
  feature = 230,
  connector = 230,
  integration = 230,
  default = 230,
  campaigns = 230,
}
export enum addProductEnum {
  addFailureMessage = 'Unable to add this product.',
  addNewProductDescription = 'To enable ICE in your products, onboard them here.',
  addNewProductTitle = 'Onboard a Product',
}

export enum manageProductEnum {
  addNewConfiguration = 'Add New Configuration',
  addNewConfigurationMessage = 'To customize the ICE experience for specific product versions or customers, add a configuration here.',
}

export enum connectorEnum {
  connectorFail = 'Something unexpected happened. How would you like to proceed?',
  refreshIntervalHelperTextValid = 'Enter numeric values only (except zero or negative numbers).',
  refreshIntervalHelperTextInValid = 'Enter numeric values only',
  refreshIntervalLabel = 'Time Unit',
  refreshIntervalPlaceholder = 'Choose Time Interval',
  environmentLabel = 'Environment',
  environmentPlaceholder = 'Choose environment',
  featuresLabel = 'Features',
  featuresPlaceholder = 'Choose features',
  enabledLabel = 'Is Enabled',
  connectorExistsWithName = 'Duplicate connector exists',
  noConnectorRowsMessage = 'No connectors available.',
  noFeatureRowsMessage = 'No features available',
  addFailureMessage = 'Unable to add this connector.',
  minimumTime = 'The minimum time is 15 minutes.',
  featureName = 'Feature Name',
  searchFeature = 'Search features',
  connectorScreenTitleFirst = 'Connector created successfully',
  connectorScreenTitleLast = 'Add a Connector',
  addConnectorDescription = 'To enable data sources in ICE, add your connectors here.',
  deleteConnectorFailureMessage = 'Unable to delete this connector.',
  connectorDescriptionEdit = 'Connector Description',
  description = 'description',
  connectorTitle = 'Connector Name',
  providerKey = 'Provider Key',
  refreshInterval = 'Refresh Interval',
  connectorUrl = 'Connector URL',
  providerUrl = 'Provider URL',
  toFeatures = 'Feature(s)',
  enableConector = 'Enable Connector',
  createConnector = 'Create Connector',
  features = 'Feature(s)',
  title = 'Title',
  Description = 'Description',
  refreshIntervalPeriod = 'Refresh Interval Period',
  searchConnector = 'Search Connectors',
}
export enum ManageConnectorEnum {
  titleLabel = 'Title',
  titlePlaceHolder = 'Connector Name',
  descriptionLabel = 'About This Connector',
  urlLabel = 'Connector URL',
  urlPlaceHolder = 'Connector URL',
  providerKeyLabel = 'Provider Key',
  providerKeyPlaceHolder = 'Provider Key',
  refreshIntervalLabel = 'Refresh Interval',
  refereshTimeLabel = 'The minimum time is 15 minutes.',
  selectedFeatureLabel = 'Feature(s) Linked to this Connector',
  selectFeatureTablePlaceHolder = 'At least one feature must be selected.',
  providerKeyValue = 'Not set',
}

export enum customerEnums {
  nameExistsEnum = 'Duplicate customer exists',
  siteId = 'Site ID',
  customerName = "Customer's Name",
  enableDisableCustomer = 'Enable Customer',
  CreateCustomer = 'Create Customer',
  FailureMessage = 'Something unexpected happened. How would you like to proceed?',
  name = 'Name',
  isenabled = 'Is Enabled',
  newCustomer = 'Add Customer',
  saveChanges = 'Save Changes',
  deleteFailureMessage = 'Unable to delete this customer.',
  addNewCustomer = 'Onboard a Customer',
  addNewCardDescription = 'To personalize the ICE experience for your customers, onboard them here.',
  productsEnabled = 'Products Enabled',
  searchCustomers = 'Search Customers',
  noRowMessage = 'No customers available.',
  addFailureMessage = 'Unable to add this customer.',
  customerDescription = 'Customer description',
  save = 'Save',
  reset = 'Reset',
  defaultSiteId = 'No Site ID added',
}
export enum ManageCustomerEnum {
  titleLabel = 'Customer Name',
  titlePlaceHolder = 'Customer Name',
  descriptionLabel = 'About This Customer',
  siteIdLabel = 'Customer Site ID',
  siteIdPlaceHolder = 'Customer Site ID',
}

export enum unsavedAlertDialogEnum {
  unsavedAlertDialogTitle = 'Leave this page?',
  unsavedAlertDialogContent = "If you leave now, you'll have to start over.",
  unsavedAlertSubTitle = 'You have unsaved changes here. You will lose them if you exit now.',
}

export enum customeOverlayMessage {
  noResultCustomerMessage = 'Sorry, no customers found',
  customerMessage1 = 'Looks like you have not onboarded any customers yet.',
  customerMessage2 = 'Once onboarded, you can link your customers to products.',
  noResultMessage = 'Sorry, no results found',
  message1 = '',
  message2 = 'Try searching for something else.',
  noOverlayMessage = 'No product versions available',
}

export enum commonMessagesEnum {
  required = 'Required',
  cancel = 'Cancel',
}

export enum featuresEnum {
  displayOrderHelperTextValid = 'Enter numeric values only (except zero or negative numbers).',
  displayOrderHelperTextInValid = 'Enter numeric values only',
  title = 'Title',
  displayOrder = 'Display Order',
  plugin = 'Plugin',
  choosePlugin = 'Choose Plugin',
  type = 'Type',
  clearPlugin = 'Clear Selection',
  chooseType = 'Choose Type',
  enabledLabel = 'Is Enabled',
  excludeInList = 'Exclude In List',
  newFeature = 'Add Feature',
  saveChanges = 'Save Changes',
  cancel = 'Cancel',
  nameExistsEnum = 'Duplicate feature exists',
  cardType = 'Card Type',
  featureTitle = 'Feature Name',
  changeIcon = 'Change Icon',
  pluginSelection = 'Plugin Selection',
  noPluginRowsMessage = 'No Plugins available',
  featureDisplayOrder = 'Feature Display Order',
  excludeFeature = 'Exclude this Feature',
  selectPlugin = 'Select Plugin',
  enableDisableFeature = 'Enable Feature',
  createFeature = 'Create Feature',
  searchFeatures = 'Search Features',
  deleteFailureMessage = 'Unable to delete this feature.',
  noRowMessage = 'No features available.',
  addANewFeature = 'Add a Feature',
  addNewCardDescription = 'To implement unique capabilities in ICE, add features here.',
  save = 'Save',
  reset = 'Reset',
  skipPlugin = 'I will do this later',
  skipPluginDescription = 'Select this if you do not see your plugin or want to add the plugin later',
  selectIcon = 'Select Icon',
}

export enum ManageFeatureEnum {
  titleLabel = 'Feature Name',
  titlePlaceHolder = 'Feature Name',
  descriptiponLabel = 'About This Feature',
  cardTypeLabel = 'Card Type',
  selectedIconLabel = 'Selected Icon',
  selectedIconEditLabel = 'Change Selected Icon',
  displayOrderLabel = 'Display Order',
  displayOrderEditLabel = 'Drag and drop the cards to edit the display order',
  selectPluginLabel = 'Plugin Linked to this Feature',
  excludeFeatureLabel = 'Feature Excluded from the ICE Panel List?',
  noFeature = 'None',
  cannotbeenabled = 'You must link a plugin to this feature before you can enable it.',
  unlinkPluginConfirmationModalTitle = 'Warning',
  unlinkPluginConfirmationModalSubtitle1 = 'This feature will be disabled if no plugin is linked to it. Do you still want to clear the plugin selection?',
  unlinkPluginConfirmationModalSubtitle2 = 'This feature will remain disabled until a plugin is linked to it. Do you still want to clear the plugin selection?',
  unlinkPluginConfirmationModalCancelButtonLabel = 'Cancel',
  unlinkPluginConfirmationModalConfirmButtonLabel = 'Yes',
}

export enum pluginsEnum {
  title = 'Title',
  chooseCardType = 'Choose Card Type',
  cardType = 'Card Type',
  icon = 'Icon',
  iconType = 'Icon Type',
  chooseIconType = 'Choose Icon Type',
  pluginPath = 'Plugin Path',
  pluginBinary = 'Plugin Binary File',
  isEnabled = 'Is Enabled',
  newPlugin = 'Add Plugin',
  saveChanges = 'Save Changes',
  editPluginErrorMessage = 'Unable to edit this plugin.',
  pluginAddMessage = 'To define features, add your plugin binaries here.',
  pluginTitle = 'Plugin Name',
  nameExistsEnum = 'Duplicate plugin exists',
  selectIcon = 'Icon',
  uploadMessage = 'Only Tarball files (.tgz) are allowed.',
  createPlugin = 'Create Plugin',
  addPlugin = 'Add a Plugin',
  addSuccesMessage = 'Plugin created successully!',
  deleteFailureMessage = 'Unable to delete this plugin.',
  save = 'Save',
  reset = 'Reset',
}
export enum ManagePluginEnum {
  titleLabel = 'Plugin Name',
  titlePlaceHolder = 'Plugin Name',
  descriptionLabel = 'About This Plugin',
  cardTypelabel = 'Card Type',
  selectedIconLabel = 'Selected Icon',
  selectedIconEditLabel = 'Change Selected Icon',
  pluginBinaryLabel = 'Plugin Binary File',
  noFeatures = 'None',
}
export enum integrationsEnum {
  titleExistsMessage = 'Duplicate integration exists',
  enableDisableIntegration = 'Enable Integration',
  integrationTitle = 'Integration Name',
  CreateIntegration = 'Create Integration',
  notFound = "Sorry, we couldn't add your Integration.",
  CreationFailureMessage = 'Something unexpected happened. How would you like to proceed?',
  failureIntegrationMesage = 'Return to the first step in adding a new integration.',
  failureAction = 'Back to integrations management',
  failureActionDescription = 'Return to the integrations management page so you can view and manage my integration.',
  newIntegration = 'Add Integration',
  saveChanges = 'Save Changes',
  AddIntegrationDescription = 'To extend the capabilities of ICE through external tools, add integrations here.',
  addNewIntegration = 'Add an Integration',
  searchIntegrations = 'Search Integrations',
  deleteFailureMessage = 'Unable to delete this integration.',
  noRowMessage = 'No integrations available.',
  addIntegrationFailureMessage = 'Unable to add this integration.',
  integrationDescription = 'Integration Description',
}
export enum ManageIntegrationEnum {
  titleLabel = 'Integration Name',
  titlePlaceHolder = 'Integration Name',
  descriptionLabel = 'About This Integration',
}

export enum dashboardEnums {
  dashboardMessage = 'Welcome to ICE Admin',
}
export enum MetaDataGeneratorEnums {
  addUrl = 'Add Another URL',
  heroId = 'Hero Description ID',
  type = 'Type',
  copied = 'Copied to clipboard',
  chooseType = 'Choose Type',
  invalidUrlMessage = 'Enter a valid URL',
  createAnotherGuide = 'Create another guide',
  createGuide = 'Create a guide',
  createAnotherCard = 'Create another card',
  createCard = 'Create a card',
  clearAll = 'Clear All',
  generate = 'Generate',
  fetchErrorMessage = 'Not able to retrieve  metadata. Try again in some time.',
  createNew = 'Create New Metadata',
  createFrom = 'Create from Existing Metadata',
  getMetadata = 'Get metadata',
  helperText = "Enter your product's relative URL where metadata must be displayed; do not add the domain here.",
  customCards = 'Custom Cards',
  metaDataPreview = 'Metadata Preview',
  copyToClipboard = 'Copy to clipboard',
  cardsPreview = 'Cards Preview',
  contextUrl = 'Context URL',
  guides = 'Guides',

  id = 'ID',
  title = 'Title',
  metaDataUrl = 'Metadata URL',
  errorMessage = 'Enter a valid url',
  additionalUrlLabel = 'Additional KB URL',
  heroDescriptionHelperText = 'Enter the ID of the element containing the description to be displayed above the cards, in the ICE panel.',
  idHelperText = 'Enter the ID of the element containing the data to be displayed in this card, in the ICE panel.',
  titleHelperText = 'Add the title of the card.',
  urlHelperText = "If the element is on a different page than the metadata's destination, enter its URL.",
  masterUrlHelperText = 'Enter the knowledge base URL that contains the list of all other knowledge bases.',
  additionalHelperText = 'Enter a relevant knowledge base URL.',
  metaDataUrlHelperText = 'Enter the URL of a page with existing metadata.',
  noMetaFoundMessage = 'No metadata found on this URL. Create it now',
  videoURL = 'Video URL',
  videoHelperText = 'Enter the video URL.',
  contextUrlPlaceHolder = 'E.g. /roadmaps',
  heroPlaceHolder = 'E.g. Projects',
  typeHelperText = 'Select the type of card for which you will generate metadata.',
  idPlaceHolder = 'E.g. IPCE_Admin',
  titlePlaceHolder = 'E.g. Administering Roadmaps',
  urlPlaceHolder = 'E.g. https://techdocs.broadcom.com/us/en/ca-enterprise-software/business-management/clarity-project-and-portfolio-management-ppm-on-premise/16-1-1/using/new-user-experience-create-open-and-view-projects.html',
  videoURLPlaceHolder = 'E.g. https://www.youtube.com/watch?v=icDEiUWT_tY',
  additionalUrlPlaceholder = 'E.g. https://knowledge.broadcom.com/external/article?articleId=21314',
  pendoIdPlaceHolder = 'Pendo ID',
  pendoTitlePlaceHolder = 'Pendo Title',
  MetaDataUrlPlaceHolder = 'E.g. http://www.techdocs.com/ae4b-Tr14',
  MasterKBUrlPlaceHolder = 'E.g. https://knowledge.broadcom.com/external/article?articleId=21412',
  pendoIdHelperText = 'Add the pendo guide ID that is provided by the product.',
  pendoTitleHelperText = 'Add a title to be displayed in ICE.',
}

export enum MetaDataCusomCardsPriority {
  default = 'default',
  custom = 'custom',
  hide = 'hide',
}

export enum CreationSuccessEnums {
  description = 'What would you like to do next?',
  customerTitle = 'Associate product(s) with this customer',
  customerDescription = 'Choose a product to customize the ICE experience for this customer.',
}
export enum FooterEnum {
  title = '© 2023 Broadcom. All Rights Reserved.',
}

export enum Configurations {
  noConfigurationFound = 'This configuration does not exist.',
}

export enum FailureScreenMessage {
  title = 'Retry',
}
export enum ReIndexerEnum {
  cancelButton = 'Cancel',
  reIndexButton = 'Reindex',
  placeHolder = 'E.g. http://www.techdocs.broadcom.com/ppm',
  label = 'URL',
  errorHelperText = 'Enter a valid URL',
  helperText = 'Enter the URL to be reindexed.',
  successMessage = 'Success',
}

export enum MetaDataCustomCardsEnums {
  cardsDefaultPriority = 'Prioritize Default Cards',
  cardsCustomPriority = 'Prioritize Custom Cards',
  defaultCardsHide = 'Hide Default Cards',
  addUrl = 'Add another URL',
  helperText = "Enter your product's relative URL where metadata must be displayed; do not add the domain here.",
  createAnotherCard = 'Create another card',
  createCard = 'Create a card',
  generate = 'Generate',
  clearAll = 'Clear All',
  cardTypeName = 'Name',
  cardTypeTitle = 'Name',
  cardTypePlaceHolder = 'Choose Icon',
  cardIdLabel = 'ID',
  cardIdPlaceHolder = 'E.g. IPCE_CustomCard',
  cardIdHelperText = 'Enter the ID of the element containing the data to be displayed in this card, in the ICE panel.',
  cardTitleLabel = 'Title',
  cardTitlePlaceHolder = 'Custom Title here',
  cardTitleHelperText = 'Add a title for the custom card.',
  cardDescriptionLabel = 'Description',
  cardDescriptionHelperText = 'Add a description for the custom card. Maximum limit: 256 characters',
  cardDataLabel = 'Data',
  cardDataHelperText = 'Add information to be displayed on clicking the custom card.',
  cardEndPointLabel = 'Endpoint',
  cardCallToActionLabel = 'Call to action',
  cardCallToActionHelperText = 'Add a call to action.',
  cardCallToActionErrorHelperText = 'Please enter a valid URL',
  cardEndPointPlaceHolder = '',
  cardEndPointHelperText = 'Add an endpoint (required only if the customer wants to host the content on-prem).',
  urlLabel = 'URL',
  urlPlaceHolder = 'E.g. /roadmaps',
  cardsResetLabel = 'Reset',
  createConfigration = 'Create Configuration',
  updateConfiguration = 'Update Configuration',
}
export enum SettingsEnum {
  title = 'Grant Product Access',
  emailLabel = 'Email Address',
  emailPlaceHolder = 'Enter valid email address',
  emailErrorMessage = 'Enter a valid email address',
  productLabel = 'Product List',
  productPlaceHolder = 'Select Product',
  clearButton = 'Clear All',
  grantAcess = 'Grant Access',
  SuccessMessage = 'Success',
  adminMessage = 'This user is an admin and can access all products in ICE Admin',
  selectedProducts = 'Retreiving the selected products',
  // grant access
  grantAccessPageTitle = 'Grant Access',
  grantAccessCardSubTitle = 'To grant product and/or custom configuration access to someone else, click here.',
  grantAccessPageTitleWithEmail = 'Granting access to',
  grantAccessPageSuccessTitle = 'Access granted successfully',
  grantAccessEmailFieldTitle = 'Provide the email address of the collaborator',
  grantAccessEmailFieldHilightTitle = 'email address',
  grantAccessEmailFieldSubTitle = 'They will receive access to the ICE Admin tool.',
  grantAccessProductFieldTitle = 'Which product does the collaborator need to access?',
  grantAccessProductFieldHilightTitle = 'product',
  grantAccessProductFieldSubTitle = 'Select a product from the dropdown list below.',
  grantAccessConfigurationsFieldTitle = 'Which configuration(s) does the collaborator need to access?',
  grantAccessConfigurationsFieldSubTitle = 'Select one or more configurations from the dropdown list below.',
  grantAccessConfigurationsFieldHilightTitle = 'configuration(s)',
  grantAccessCustomersFieldTitle = 'Manage selected customers(s)',
  grantAccessCustomersFieldHilightTitle = 'customer(s)',
  grantAccessCustomersFieldSubTitle = 'The selected customers listed below are associated with your chosen configurations. However, you can add or remove customers as needed.',
  grantAccessRoleFieldTitle = 'What is the collaborator’s role?',
  grantAccessRoleFieldHilightTitle = 'role',
  grantAccessRoleFieldSubTitle = 'Select the collaborator’s role from the dropdown list below.',
  grantAccessSuccessCardTitle = 'Grant Access',
  grantAccessSuccessCardSubTitle = 'I want to go back and give access to a new user.',

  // revoke access
  revokeAccessPageTitle = 'Revoke Access',
  revokeAccessCardSubTitle = 'To revoke product and/or custom configuration access from someone else, click here.',
  revokeAccessPageTitleWithEmail = 'Revoking access from',
  revokeAccessPageSuccessTitle = 'Access revoked successfully',
  revokeAccessEmailFieldTitle = 'Provide the email address of the collaborator',
  revokeAccessEmailFieldSubTitle = 'You can revoke their access to the ICE Admin tool',
  revokeAccessEmailFieldHilightTitle = 'email address',
  revokeAccessProductFieldTitle = 'Revoke Product Access',
  revokeAccessProductFieldSubTitle = 'To revoke access to specific products, select them from the dropdown list below. To revoke access to specific product configurations, proceed to the next step.',
  revokeAccessProductFieldHilightTitle = 'Product',
  revokeAccessConfigurationsFieldTitle = 'Revoke Configuration(s) access',
  revokeAccessConfigurationsFieldSubTitle = 'To revoke access to specific custom configurations, remove them from the list below.',
  revokeAccessConfigurationsFieldHilightTitle = 'Configuration(s)',
  revokeAccessCustomersFieldTitle = 'Revoke Customer(s) access',
  revokeAccessCustomersFieldSubTitle = 'To revoke access to specific customers, remove them from the list below.',
  revokeAccessCustomersFieldHilightTitle = 'Customer(s)',
  revokeAccessSuccessCardTitle = 'Revoke Access',
  revokeAccessSuccessCardSubTitle = 'Return to the first step of revoking access from a new collaborator.',
  revokeAccessRemoveProductModalTitle = 'Confirmation',
  revokeAccessRemoveProductModalSubTitle1 = 'By deleting entire product you cant access this product in future and all the respective data will be removed permanently',
  revokeAccessRemoveProductModalSubTitle2 = 'This opertion is irreversable',
  revokeAccessRemoveProductModalCancelButtonLabel = 'Cancel',
  revokeAccessRemoveProductModalConfirmButtonLabel = 'Confirm',
  revokeAccessunsavedAlertSubTitle = 'Are you sure you want to leave without revoking access?',
  unableToRevokeAccess = 'Unable to Revoke Access',
  unableToGrantAccess = 'Unable to Grant Access',

  unsavedAlertDialogTitle = 'Leave this page?',
  unsavedAlertDialogContent = "If you leave now, you'll have to start over.",
  grantAccessunsavedAlertSubTitle = 'Are you sure you want to leave without granting access?',

  grantAndRevokeSuccessTitle = 'Awesome Job!',
  grantSuccessSubTitle1 = 'You have successfully granted',
  grantSuccessSubTitle2 = 'access to',
  revokeSuccessSubTitle = 'You have successfully revoked access from',

  removeProductButtonLabel = 'Remove Product',
  emailPlaceholder = 'example@gmail.com',
  rolesButtonLabel = 'Role',
  emailButtonLabel = 'Email Address',
  configurationButtonLabel = 'Configuration(s)',
  customersButtonLabel = 'Customer(s)',
  nextButtonLabel = 'Next',
  productsButtonLabel = 'Products',
  rolesFieldPlaceholder = 'Select Role',
  productsFieldPlaceholder = 'Select Products',
  resetButtonLabel = 'Reset',
  revokeButtonLabel = 'Revoke Access',
  grantAccessButtonLabel = 'Grant Access',
  noProductsAvailable = 'No Products Associated',
  noConfigurationsAvailable = 'No Configurations Associated',
  noCustomersAvailable = 'No Customers Associated',
  configurationsAllConfigOption = 'All Configurations',
  customerssAllCustomersOption = 'All Customers',
  emailInvalidMessage = 'Enter a valid email address',
  emailUserIsAdminErrorMessage = 'This user is an admin and can access all of ICE Admin',
  emailUserNotFoundErrorMessage = 'This user does not have any permissions',
  emailOwnAcountErrorMessage = 'You cannot modify your access to ICE Admin. Try another email address.',
}
export const CreationSuccessManageTitle = (type: string) => {
  return `Manage ${toTitleCase(type.toLowerCase())}s`;
};
export const CreationSuccessManageDescription = (type: string) => {
  return `Return to the ${type.toLowerCase()}s management page.`;
};
export const CreationSuccessAddItemTitle = (type: string) => {
  return `Add a New ${toTitleCase(type.toLowerCase())}`;
};
export const CreationSuccessAddItemDescription = (type: string) => {
  return `Return to the first step of adding a new ${type.toLowerCase()}.`;
};
export const CreationSuccessEditItemTitle = (type: string) => {
  return `Edit ${toTitleCase(type.toLowerCase())}`;
};
export const CreationSuccessEditItemDescription = (type: string) => {
  return `Update details of the ${type.toLowerCase()} you just ${
    type === Types.customer ? 'onboarded' : 'created'
  }.`;
};
export const CreationFailureMessage = (type: string, title?: string) => {
  return `Sorry, we couldn't
  ${type === 'customer' ? ' onboard' : ' add'}  ${
    title ? title : `your ${type}`
  }`;
};
export const CreationSuccessMessage = (type: string) => {
  return type === Types.product
    ? `You have successfully enabled ICE on`
    : `You have successfully added`;
};
export const CreationSuccessOnboardMessage = (type: string) => {
  return `${type} ${
    type === (Types.customer || Types.product) ? 'onboarded' : 'created'
  } successfully`;
};
export const CreationFailueRetryDescription = (type: string) => {
  return `Resubmit the details entered to ${
    type === 'customer' ? ' onboarding' : 'create this'
  } ${type}.`;
};
export const CreationFailueManageDescription = (type: string) => {
  return `Return to the ${type} management page.`;
};
export const CreationFailureManageTitle = (type: string) => {
  return `Manage ${type}`;
};

export const CreationAlertMessage = (type: string) => {
  return `Your creation ${
    type ? `'${type}'` : ``
  } is still in progress. Are you sure you want to leave it?`;
};

export const CreatingItem = (title: string) => {
  return `Adding ${title}`;
};
export const EnableDisable = (title: string, type?: string) => {
  return `When do you want to enable ${
    type === Types.product ? 'ICE on' : ''
  } ${title}?`;
};

export const DeleteSuccessMessage = (title: string) => {
  return `${title} was successfully deleted`;
};
export enum action {
  edit = 'edit',
  delete = 'delete',
}

export enum DashboardEnum {
  title = 'Home',
}

export enum DynamicUrlGeneratorEnum {
  title = 'Enter the URL that you want to make dynamic.',
  selection_Description = 'To select dynamic parts of the URL, click on them.',
  titleHelperText = 'Enter the dynamic URL.',
  selectionHelperText = 'At least one dynamic part must be selected.',
  displayTermHelperText = 'This will be displayed above all the cards in the ICE panel.',
  searchTermHelperText = 'Enter one or more search words (separated by commas) to display relevant content.',
  saveUrlButton = 'Save URL Pattern',
  displayTerm = 'Display Term',
  searchTerm = 'Search Terms',
}

export const ConfigurationErrorMessage = 'Is This Configuration Active?';
export const ToggleProductMessage = 'Is ICE Enabled in This Product?';

export const ToggleMessage = (type: string) => {
  return type === 'Configuration'
    ? ConfigurationErrorMessage
    : type === 'Product'
    ? ToggleProductMessage
    : `Show this ${type} in Product Configurations?`;
};

export enum NetworkErrorEnum {
  message = 'Whoops! there seems to be a problem with your network connection',
}

export const FailureMessage = (title: string) => {
  return `Something unexpected happened and ${title} could not be added. How would you like to proceed?`;
};

export const SearchNotFoundMessage = (type: string) => {
  return `We could not find the ${type
    .toLowerCase()
    .slice(0, -1)}. It may have been deleted`;
};

export const toTitleCase = (str?: string) => {
  return str?.replace(/\b\w/g, (txt: string) => {
    return txt.toUpperCase();
  });
};

export const RefereshPopupTitle = (type: string) => {
  return type === 'sessionExpired'
    ? 'Session Expired'
    : 'Your Product Access has Changed';
};

export const RefereshPopupDescription = (type: string) => {
  return type === 'sessionExpired'
    ? 'Please refresh the page to continue.'
    : 'Please refresh the page to continue.';
};
export const EmptyProductsMessage =
  'No products onboarded to ICE Admin yet. Onboard a product first to run a campaign on it.';
export const AddCampaignMessage = {
  titleProps: {
    title: "What is your campaign's name?",
    subTitle:
      'Enter the name of the campaign that you want to run on ICE-enabled product(s).',
    textToHighlight: "campaign's name",
  },
  titleButtonProps: {
    nextItemLabel: 'Description',
  },
  titleFieldProps: {
    duplicateMessage: 'Duplicate campaign exists',
    maxLimitMessage: 'Maximum limit: 125 characters',
    placeHolder: 'Campaign Name',
  },
  descriptionProps: {
    title: 'Provide a campaign description',
    subTitle:
      'In a few lines, describe your campaign to provide some context about it.',
    textToHighlight: 'campaign description',
  },
  descriptionButtonProps: {
    nextItemlabel: 'Timeframe',
    previousItemlabel: "Campaign's Name",
  },
  dateProps: {
    title: 'Set a timeframe for your campaign',
    subTitle: 'It can be just for today or for as long as you want.',
    textToHighlight: 'timeframe',
  },
  dateButtonProps: {
    nextItemlabel: 'Product(s)',
    previousItemlabel: 'Description',
  },
  productProps: {
    title: 'Product(s)',
    subTitle: 'Choose the product(s) in which you want to run this campaign.',
    textToHighlight: 'product(s)',
  },
  productButtonProps: {
    previousItemlabel: 'Timeframe',
    nextItemlabel: 'Configuration(s)',
  },
  configurationProps: {
    title: 'Configuration(s)',
    subTitle:
      'Choose the product configuration(s) in which you want to run this campaign. The baseline configuration is selected by default for each product.',
    textToHighlight: 'configuration(s)',
    getDynamicCount: (count: number) => {
      const statement = `This campaign is visible to ${count} customer${
        count === 1 ? '' : 's'
      }.`;
      return statement;
    },
  },
  configurationButtonProps: {
    nextItemlabel: 'Create Campaign',
    previousItemlabel: 'Products',
  },
};

export const AddCampaignCard = {
  title: 'Add a Campaign',
  description: 'Add a campaign to run on product(s) enabled with ICE.',
};
export const EditCampaignMessages = {
  nonEditable:
    'Except the end date, you cannot edit any details on or after the campaign start date.',
  nonEditableEnd: 'You cannot edit these details after the campaign has ended.',
  titleLabel: 'Campaign Name',
  descriptionTitle: 'About This Campaign',
  descriptionLabel: 'Campaign Description',
  productTitle: 'Products',
  configurationTitle: 'Configurations & Customers',
  datesTitle: 'Campaign Timeframe',
  statusTitle: 'Campaign Status',
  createdByTitle: 'Created By',
  notificationMessages:
    'The below notifications lie outside the campaign timeframe. They will be visible only while the campaign is running.',
  customersAssociated:
    ' included in this campaign as per the configurations selection',
  customerListTitle: 'Customer List for ',
  customConfigurations: 'Custom Configuration(s)',
};

export const NotificationMessages = {
  nameLabel: 'Name',
  titleLabel: 'Title',
  untitledNotif: 'Untitled Notification',
  manage: 'Notification actions',
  invalidNotification:
    "The notification name cannot be 'Untitled Notification'",
  delete: {
    title: 'Delete Notification',
    message:
      'Deleting this notification will permanently remove it from the system. This action cannot be undone.',
  },
  descriptionTitle: 'Description',
  descriptionLabel: 'Campaign Description',
  productTitle: 'Products',
  configurationTitle: 'Configurations',
  datesTitle: 'Start Date - End Date',
  statusTitle: 'Status',
  createdByTitle: 'Created By',
  lastUpdatedBy: 'Last Updated By',
  RedirectTitlePlaceholder: 'Title',
  RedirectLinkPlaceHolder: 'Link',
  AddRedirect: 'Add Redirect URL',
  TriggerRoutePlaceHolder: 'Trigger Route',
  TriggerRouteHelperText:
    'Enter the product routes (URLs) where the notification must appear.',
  AddTrigger: 'Add a new trigger route',
  TriggerRouteLabel: 'Trigger Routes',
  TriggerTypeLabel: 'Trigger Type',
  TriggerTypeHelperText:
    'Select how you want the notification to be delivered.',
  TriggerHandlerLabel: 'Trigger Handler',
  TriggerHandlerHelperText: 'Select where the notification must be handled.',
  EditNotificaionTitle: 'Title',
  NotificatinNotFound: 'No notifications here yet',
  AddNotification: 'Add a New Notification',
  LinkLabel: 'Link',
  deleteNotificationSuccessMessage: `This notification has been deleted successfully`,
  deleteNotificationFailureMesssage: 'Unable to delete this notification',
  addNotificationMessage: 'Add New Notification',
  notificationTriggerNoTriggers: 'No trigger routes added',
  notificationTriggerAddNewTrigger: 'Add a new trigger route',
};
export const TranslatorEnums = {
  title: 'Localization Table',
  description: '',
  addNew: 'Add New Key',
  addLanguage: 'Add New Language(s)',
  cancel: 'Cancel',
  save: 'Save',
  keyTitle: 'Key',
  addNewKeyTitle: 'Add New Key',
  keyPlaceHolder: 'E.g. ipce_get_started',
  deleteKeySuccessMessage: 'This key has been deleted successfully',
  deleteKeyFailureMessage: 'Unable to delete this key',
  addKeySuccessMessage: 'Localization key added successfully',
  updateKeySuccessMessage: 'Localization key updated successfully',
  addKeyErrorMessage: 'Key cannot be added',
  updateKeyErrorMessage: 'Key cannot be updated',
  keyHelperText: 'Enter the key associated with the string you want to add.',
  keyErrorMessage: 'Duplicate key exists',
  searchLanguage: 'Search Language',
  selectAll: 'Select All',
  selectLanguages: 'Select Language(s)',
  ErrorMessage: 'Row can not be updated',
  type: 'Localization keys',
  noKeysMessage: 'No Localization keys found',
};

export const getAllFieldsMandatory = (value: string) => {
  return `Key and ${value} are mandatory.`;
};

export const getUniqueKeyMessage = () => {
  return `Duplicate key exists`;
};

export const getaColumnMandatory = (value: string) => {
  return `${value} is mandatory.`;
};

export enum ApplicationTabsEnum {
  DASHBOARD = 'dashboard',
  PRODUCTS = 'products',
  GENERAL = 'general',
  CONFIGURATIONS = 'configurations',
  VERSIONS = 'versions',
  CUSTOMERS = 'customers',
  CAPABILITIES = 'capabilities',
  ROUTES = 'routes',
  URL_PATTERNS = 'urlPatterns',
  LOCALIZATION_TABLE = 'localizationTable',
  FEATURES = 'features',
  PLUGINS = 'plugins',
  CONNECTORS = 'connectors',
  INTEGRATIONS = 'integrations',
  META_GENERATORS = 'metaGenerators',
  REINDEX_CONTENT = 'reindexContent',
  CAMPAIGNS = 'campaigns',
  TRIGGERS = 'triggers',
  NOTIFICATIONS = 'notifications',
  REDIRECTS = 'redirects',
  ACCESS = 'productAccess',
  CUSTOM_CONTENT = 'customContent',
  PRODUCT_ACCESS = 'productAccess',
  GRANT = 'grant',
  REVOKE = 'revoke',
}

export enum NoConfigurationsString {
  noProductsFound = 'No products found',
  noConfigurationsFound = 'No custom configurations found',
  addNewConfiguration = 'Add a new Configuration',
}
export const disableConfirmTitle = (type: string) => {
  return `Disable this ${type}?`;
};

export enum DisableConfirmStrings {
  save = 'Save',
  exit = 'Exit',
}
export const disableConfirmSubTitle = (type: string) => {
  const impact = dependecies[type as keyof typeof dependecies]?.join(' and ');
  return `Are you sure you want to disable this ${type}? It will impact ${impact}.`;
};

export const dependecies = {
  product: ['other products'],
  customer: ['products'],
  feature: ['connectors', 'products'],
  plugin: ['features', 'products'],
  integration: ['products'],
  connector: ['products'],
};

export enum TabsToLoad {
  general = 'General',
  version = 'Versions',
  customers = 'Customers',
  capabilities = 'Capabilities',
  routes = 'Routes',
  urlPatterns = 'URL Patterns',
  localizationTable = 'Localization Table',
  customContent = 'Custom Content',
}
